import { render, staticRenderFns } from "./confirmSecretCodeToShowAddresses.popup-chunk.vue?vue&type=template&id=dd56bf8a&scoped=true"
import script from "./confirmSecretCodeToShowAddresses.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./confirmSecretCodeToShowAddresses.popup-chunk.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd56bf8a",
  null
  
)

export default component.exports